<ng-container *ngIf="background && (!image || !imageLoaded)">
  <div *ngIf="showPlaceholder && placeholder; else default"
    [style.backgroundImage]="brandedPlaceholder"
    class="image loaded"></div>

  <ng-template #default>
    <div *ngIf="showPlaceholder"
      [style.backgroundImage]="defaultPlaceholder"
      class="after"></div>

  </ng-template>
</ng-container>
<ng-container *ngIf="image">
  <div [style.backgroundImage]="localBackground"
    class="image"
    [class.loaded]="imageLoaded"></div>
  <img *ngIf="image && !imageLoaded"
    [src]="image"
    (load)="setImageLoaded()"
    class="scratch">
</ng-container>